// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"923":"bef9806e","938":"52807d0c","1548":"6b610a10","1631":"bebfbc49","3524":"cc1df921","6672":"e0bf6d12","8149":"ce20fce7","9292":"73ab4c84","9336":"cb3b7df1"}[chunkId] + ".chunk.css";
};